import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][appEllipsis]',
  standalone: true,
})
export class EllipsisDirective {
  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly matTooltip: MatTooltip,
  ) {}

  @HostListener('mouseenter')
  onResize(): void {
    const element = this.elementRef.nativeElement;
    // 内容が切り捨てられている場合のみツールチップを表示
    this.matTooltip.disabled = element.scrollWidth <= element.clientWidth;
  }
}
